import { HTMLAttributes, ReactNode, forwardRef, useState } from 'react';
import { AnimatePresence, AnimationProps, motion } from 'framer-motion';
import { cn, getMotionProps } from '../../libs';
import { ChevronDown, ChevronRight } from '../../icons';

interface CollapseViewProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  children?: ReactNode;
  extraRight?: ReactNode;
  initialOpened?: boolean;
  motionProps?: AnimationProps;
}

const entryMotionProps = getMotionProps({
  initial: { paddingTop: 0, height: 0, opacity: 0 },
  animate: { paddingTop: 8, height: 'auto', opacity: 1 },
  exit: { paddingTop: 0, height: 0, opacity: 0 },
});

export const CollapseView = forwardRef<HTMLInputElement, CollapseViewProps>(function CheckBoxContainer(
  { children, label, extraRight, initialOpened = false, motionProps, ...rest },
  ref,
) {
  const [opened, setOpened] = useState(initialOpened);
  return (
    <div className={cn('border-b border-border-secondary', rest.className)} ref={ref}>
      <div
        className={cn('flex cursor-pointer select-none items-center gap-3 p-3 text-caption-md')}
        onClick={() => setOpened(!opened)}
      >
        {opened ? <ChevronDown className="text-text-brand-primary" /> : <ChevronRight />}
        <span className={cn('text-paragraph-sm font-semibold', opened ? 'text-text-primary' : 'text-text-secondary')}>
          {label}
        </span>
        {extraRight && <div className="ml-auto">{extraRight}</div>}
      </div>
      {children && (
        <AnimatePresence>
          {opened && <motion.div {...(motionProps || entryMotionProps)}>{children}</motion.div>}
        </AnimatePresence>
      )}
    </div>
  );
});
